import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-218567e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ActivityPeriod__container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "NormalBlock"
}
const _hoisted_4 = {
  key: 1,
  class: "NormalBlock"
}

import { onBeforeMount, computed, watch } from 'vue';
import { useRouter } from 'vue-router';
// 三方组件
import { Overlay as vanOverlay } from 'vant';
import 'vant/es/overlay/style/index';
// 内部库
import toast from '@kk/toast';
import { compress } from '@kk/utils';
// 项目组件
import BroadcastBanner from '@/components/BroadcastBanner.vue';
import ruleDialog from '@/components/Dialog/ruleDialog.vue';
import prizeDialog from '@/components/Dialog/prizeDialog.vue';
import JoinDialog from '@/components/Dialog/JoinDialog.vue';
import InviteDialog from '@/components/Dialog/InviteDialog.vue';
import ShareUser from '@/components/ShareUser.vue';
import EmptyTeamGuide from '@/components/EmptyTeamGuide.vue';
import MainPanel from '@/components/MainPanel.vue';
import ActivityButton from '@/components/ActivityButton.vue';
import TeamList from '@/components/TeamList.vue';
// hook
import { useGlobalData } from '@/hooks/useGlobalData';
import { useUpadeMainPageData } from '@/hooks/useUpadeMainPageData';
import { useUpdateTeamRank } from '@/hooks/useUpdateTeamRank';
import { useTrack } from '@/hooks/useTrack';
import { useLogin } from '@/hooks/uselogin';
import { useRule } from '@/hooks/useRule';
import { usePrize } from '@/hooks/usePrize';
import { useInvite } from '@/hooks/useInvite';
import { useOffline } from '@/hooks/useOffline';
import { useNoRecord } from '@/hooks/useNoRecord';
import { useBtn } from '@/hooks/useBtn';
import { useStore } from '@/store';
import types from '@/store/types';
// API
import { getShareCode } from '@/api/getShareCode';

// 使用hook

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// 基础类库
const router = useRouter();
const store = useStore();
const global = useGlobalData();
const { trackBtn } = useTrack();
const { loginFn, clickLogin } = useLogin();
const { showRule, openRule } = useRule();
const { showPrize } = usePrize();
const { showInvite } = useInvite();
const { showOffline } = useOffline();
const { shwoNoRecord, NoRecord}  = useNoRecord();
const { showJoin } = useBtn();

// 定义常量变量
const isShare = computed(() => store.state.isShare);
const isLogin = computed(() => Boolean(store.state.user.uid));
/**
 * 活动周期
 */
const period = computed(() => store.state.period);
const teamMbmber = computed(() => store.state.currentMembers);
const shareExtendInfo = computed(() => store.state.shareExtendInfo);
const pageDataReady = computed(() => store.state.pageDataReady);
const fixedBtn = computed(() => store.getters.fixedBtn);

const backgroundStyle = computed(() => {
  let hasTeam;
  if (store.state.isShare) {
    if (store.state.joinedTeam) {
      hasTeam = true;
    } else {
      hasTeam = false;
    }
  } else {
    if (store.state.currentMembers.length > 0) {
      hasTeam = true;
    } else {
      hasTeam = false;
    }
  }
  return hasTeam
    ? { backgroundImage: `url(${compress(store.state.bannerForTeam, 750, false, true)})` }
    : { backgroundImage: `url(${compress(store.state.bannerForNoTeam, 750, false, true)})` };
});


function toRecordListView () {
  if (clickLogin()) {
    trackBtn('记录');
    router.push({ path: '/record-list' });
  }
}

watch(
  () => store.state.pageDataReady,
  (curren) => {
    if (curren) {
      if (store.state.joinedTeam && store.state.shareExtendInfo.inviteUserId) {
        if (
          !store.state.currentMembers.find(
            (member) =>
              member.userId === store.state.shareExtendInfo.inviteUserId
          )
        ) {
          toast.show({
            text: '本期已组队，不能再加入其他队伍',
          });
        }
      }
    }
  }
);

async function initShareLink () {
  if (global.isKuaikan && isLogin.value) {
    const { code, data } = await getShareCode();
    if (code === 200) {
      store.commit(types.SET_SHARE_LINK, data);
    }
  }
}

onBeforeMount(async () => {
  loginFn();
  useUpadeMainPageData();
  useUpdateTeamRank();
  initShareLink();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["HomeView__container", {
      'HomeView__container--outside': !_unref(global).isKuaikan,
      'HomeView__container--fixed': _unref(fixedBtn),
    }]),
      style: _normalizeStyle(_unref(backgroundStyle))
    }, [
      _createVNode(BroadcastBanner),
      (_unref(pageDataReady))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(period)), 1),
            _withDirectives(_createElementVNode("div", {
              class: "icon-entry record",
              "data-test": "record-btn",
              onClick: _withModifiers(toRecordListView, ["stop"])
            }, " 记录 ", 8, _hoisted_2), [
              [_vShow, _unref(global).isKuaikan]
            ]),
            _createElementVNode("div", {
              class: "icon-entry rule",
              "data-test": "rule-btn",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(openRule) && _unref(openRule)(...args)), ["stop"]))
            }, " 规则 "),
            (_unref(isShare))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(ShareUser, {
                    class: "ShareUser",
                    avatar: _unref(shareExtendInfo).inviteUserAvatar,
                    "nick-name": _unref(shareExtendInfo).inviteUserName
                  }, null, 8, ["avatar", "nick-name"]),
                  (_unref(teamMbmber).length < 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(EmptyTeamGuide, { mode: "team" })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(TeamList)
                      ]))
                ], 64))
              : (_openBlock(), _createBlock(MainPanel, {
                  key: 1,
                  class: "InviteUser"
                })),
            _createVNode(ActivityButton)
          ], 64))
        : _createCommentVNode("", true)
    ], 6),
    _createVNode(_unref(vanOverlay), {
      show: !_unref(showOffline) && _unref(showInvite),
      "z-index": 1000,
      "lock-scroll": false
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(InviteDialog), {
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showInvite.value = false))
        }))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(vanOverlay), {
      show: _unref(showRule),
      "z-index": 1000,
      "lock-scroll": false
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(ruleDialog), {
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showRule.value = false))
        }))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(vanOverlay), {
      show: _unref(showPrize),
      "z-index": 1000,
      onClick: _cache[4] || (_cache[4] = ($event: any) => (showPrize.value = false))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(prizeDialog), {
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showPrize.value = false))
        }))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(vanOverlay), {
      show: _unref(shwoNoRecord),
      "z-index": 1000
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(NoRecord)), {
          onClose: _cache[5] || (_cache[5] = ($event: any) => (shwoNoRecord.value = false))
        }))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(vanOverlay), {
      show: _unref(showJoin),
      "z-index": 1000
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(JoinDialog), {
          onClose: _cache[6] || (_cache[6] = ($event: any) => (showJoin.value = false))
        }))
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})